import * as configOverride from 'config-override';

export default {
  VUE_APP_KEYCLOAK_URL: 'http://localhost:8082',
  VUE_APP_KEYCLOAK_REALM: 'hwtest',
  VUE_APP_KEYCLOAK_REALM_ROLE_DEFAULT: 'default-roles-hwtest',
  VUE_APP_KEYCLOAK_CLIENT_ID: 'iwks-fattool',
  VUE_APP_GRAPHQL_HTTP: 'http://localhost:8081/graphql',
  VUE_APP_GRAPHQL_WS: 'ws://localhost:8081/subscriptions',
  VUE_APP_IROSE_IPS: '192.168.1.41 , 192.168.1.42 , 192.168.1.43, 192.168.1.44',
  VUE_APP_IROSE_PORTS: '12321, 12322, 12323, 12324',
  VUE_APP_IROSE_MAX_NR: '8',
  VUE_APP_IROSE_ICP_CON_NR: '0',
  VUE_APP_SLD4_IPS: '192.168.1.45,192.168.1.46,192.168.1.47,192.168.1.48,192.168.1.49,192.168.1.50',
  VUE_APP_SLD4_MAX_NR: '8',
  VUE_APP_SLD4_ICP_CON_NR: '0',
  VUE_APP_LD16_IPS: '192.168.1.82, 192.168.1.83, 192.168.1.84, 192.168.1.85',
  VUE_APP_LD16_PORTS: '7032',
  VUE_APP_LD16_MAX_NR: '8',
  VUE_APP_LD16_ICP_CON_NR: '0',
  VUE_APP_FALCON_IPS: '192.168.1.51,192.168.1.52,192.168.1.53,192.168.1.54',
  VUE_APP_FALCON_MAX_NR: '8',
  VUE_APP_KOPER_PLC: '192.168.1.55',
  VUE_APP_KOPER_DSO: '192.168.1.56, ---',
  VUE_APP_KOPER_DSZ: '192.168.1.57, ---',
  VUE_APP_PROFIBUS_IPS: '192.168.1.21,192.168.1.22,192.168.1.23,192.168.1.24,192.168.1.25,192.168.1.26',
  VUE_APP_PROFIBUS_MAX_NR: '4',
  VUE_APP_PROFIBUS_ICP_CON_NR: '0',
  ...configOverride
}

//conversie